module.exports = __webpack_public_path__ + "static/media/mar.bedaca93.jpg";